import { Controller } from '@hotwired/stimulus'
import ApexCharts from 'apexcharts'

export default class extends Controller {
  static values = { data: Array, name: String, categories: Array }

  connect() {
    this.initializeChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  initializeChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    if (!this.dataValue?.length || !this.categoriesValue?.length) return

    const maxValue = Math.max(...this.dataValue)

    const options = {
      colors: ['#FBBF24'],
      chart: {
        type: 'bar',
        toolbar: { show: false },
        height: '100%',
        parentHeightOffset: 0,
        fontFamily: 'Inter, system-ui, sans-serif',
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 600,
          animateGradually: { enabled: true, delay: 30 },
        },
      },
      title: {
        text: this.nameValue,
        align: 'center',
        style: {
          fontSize: '16px',
          fontWeight: '600',
          color: '#1f2937',
        },
      },
      series: [
        {
          name: this.nameValue,
          data: this.dataValue,
        },
      ],
      xaxis: {
        categories: this.categoriesValue,
        max: Math.ceil(maxValue * 1.15),
        labels: { show: false },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      yaxis: {
        labels: {
          maxWidth: 180,
          style: {
            fontSize: '13px',
            fontWeight: 500,
            colors: '#6b7280',
          },
        },
        axisBorder: { show: false },
        axisTicks: { show: false },
      },
      grid: {
        show: false,
        padding: { top: -10, bottom: -5, left: 10, right: 10 },
      },
      dataLabels: {
        enabled: true,
        textAnchor: 'start',
        offsetX: 6,
        style: {
          fontSize: '13px',
          fontWeight: '600',
          colors: ['#374151'],
        },
        background: { enabled: false },
      },
      tooltip: {
        enabled: true,
        intersect: false,
        theme: 'light',
        style: { fontSize: '13px' },
        y: {
          formatter: (value) => `${value} buscas`,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          distributed: false,
          barHeight: '55%',
          borderRadius: 6,
          borderRadiusApplication: 'end',
          dataLabels: {
            position: 'top',
          },
        },
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'horizontal',
          shadeIntensity: 0.15,
          opacityFrom: 1,
          opacityTo: 0.85,
          stops: [0, 100],
        },
      },
      states: {
        hover: {
          filter: { type: 'darken', value: 0.9 },
        },
      },
      legend: { show: false },
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}
